// src/admin/adminApi.js
import { useAdmin } from "./AdminContext";

const API_BASE = "https://turn.pristine.farm";

export function useAdminApi() {
  const { apiKey } = useAdmin();

  const authHeaders = apiKey
    ? { "X-Admin-Key": apiKey }
    : {};

  const getJson = async (path) => {
    const res = await fetch(API_BASE + path, {
      headers: {
        "Content-Type": "application/json",
        ...authHeaders,
      },
    });
    if (!res.ok) {
      throw new Error(`HTTP ${res.status}`);
    }
    return res.json();
  };

  const postJson = async (path, body) => {
    const res = await fetch(API_BASE + path, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        ...authHeaders,
      },
      body: body ? JSON.stringify(body) : null,
    });
    if (!res.ok) {
      throw new Error(`HTTP ${res.status}`);
    }
    return res.json();
  };

  return { getJson, postJson };
}
